import jsonwebtoken from 'jsonwebtoken';

// const secret = process.env.iamsmart_client_secret;

// const options = {
// 	algorithm: 'RS256',
// 	keyid: jwk.kid,
// 	expiresIn: 3600,
// 	audience: process.env.iamsmart_client_id,
// 	issuer: process.env.iamsmart_host,
// };
//
// export const issue = (payload) => {
// 	return jsonwebtoken.sign(payload, privateKey, options);
// }

export const extract = (token) => {
	return jsonwebtoken.decode(token);
}

// export const verify = (token) => {
// 	return jsonwebtoken.verify(token, privateKey, options);
// }
